<template>
    <div class="card">
        <div class="card-header">
            <div class="card-header__icon-wrapper">
                <mdi-icon icon="mdiDolly" class="card-header__icon" />
            </div>

            <div class="card-header__title">
                {{ t('home.widgets.orders-follow-up.title') }}
            </div>
        </div>

        <!-- Loading Spinner -->
        <div v-if="loading" class="loader-wrapper">
            <img class="block" src="/img/loader-5.gif">
        </div>

        <!-- Ongoing Orders -->
        <perfect-scrollbar v-else-if="orders.length" ref="ps" class="sl-orders">
            <div v-for="order in orders" :key="order.id" class="sl-order">
                <component
                    :is="followUpLineBuilder(order)"
                    :order="order"
                    class="sl-article-details w-9/12 xl:w-10/12"
                />

                <div
                    v-tippy="{ arrow: true, theme: 'sl-light', animation : 'fade' }"
                    class="sl-order__status w-3/12 xl:w-2/12"
                    :content="formatDateTime(status(order).at)"
                >
                    {{ t(`order_table.status.${status(order).code}.label`) }}
                </div>
            </div>
        </perfect-scrollbar>

        <!-- No Ongoing Orders -->
        <div v-else class="no-orders">
            {{ t('home.widgets.orders-follow-up.none') }}
        </div>
    </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import axios from '@/axios';
import moment from 'moment';
import LensLine from './LensLine.vue';
import StandardLine from './StandardLine.vue';
import { useI18n } from 'vue-i18n';

const store = useStore();
const { t } = useI18n({ useScope: 'global' });

const orders = ref([]);
const loading = ref(false);

onMounted(async() =>
{
    const eid = store.state.account.cEntity.id;
    loading.value = true;

    try
    {
        const response = await axios.get(`/api/order/entity/${eid}/ongoing`);
        orders.value = response.data;
    }
    catch(e)
    {
        console.log(e);
    }
    finally
    {
        loading.value = false;
    }
});

function followUpLineBuilder(order)
{
    if(order.article.tags.some(a => a.code === 'LENS'))
    {
        return LensLine;
    }

    return StandardLine;
}

function status(order)
{
    return order.status.at(-1);
}

function formatDateTime(date)
{
    return moment(date).format('DD.MM.YYYY HH:mm:ss');
}
</script>

<style scoped>
@reference "#main.css";

.card
{
    @apply min-h-[300px];
}

.loader-wrapper
{
    height: 260px;
    @apply flex justify-center items-center;
}

.sl-orders
{
    height: 260px;
    @apply w-full overflow-y-hidden;
}

.sl-order
{
    @apply flex items-center justify-between py-2 pr-2 pl-4 border-b border-gray-200;
}

.sl-article-details
{
    @apply flex;
}

.sl-order__status
{
    width: 100px;
    @apply px-3 py-2 rounded-full truncate text-center text-xs bg-primary-50 text-primary-300;
}

.no-orders
{
    @apply w-full mt-8 text-center text-gray-400;
}
</style>
